module.exports = __webpack_public_path__ + "img/filter.a07911c6.svg";